import React, { useMemo } from 'react';
import './ChristmasLights.css';

const ChristmasLights = () => {
  const lights = useMemo(() => {
    const colors = ['#ff0000', '#00ff00', '#ffff00', '#00bfff', '#ff69b4', '#ffa500'];
    return Array.from({ length: 25 }, (_, i) => ({
      id: i,
      color: colors[i % colors.length],
      delay: (i * 0.15) % 2
    }));
  }, []);

  return (
    <div className="lights-container">
      <svg className="lights-cable" viewBox="0 0 1000 60" preserveAspectRatio="none">
        <path
          d="M0,10 Q50,50 100,20 T200,30 T300,15 T400,35 T500,20 T600,30 T700,15 T800,35 T900,20 T1000,10"
          fill="none"
          stroke="#1a1a1a"
          strokeWidth="3"
        />
      </svg>
      <div className="lights-row">
        {lights.map((light, i) => (
          <div
            key={light.id}
            className="light-bulb"
            style={{
              '--light-color': light.color,
              '--delay': `${light.delay}s`,
              '--offset': `${Math.sin(i * 0.5) * 8}px`
            }}
          >
            <div className="light-cap"></div>
            <div className="light-glass"></div>
            <div className="light-glow"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChristmasLights;
